const GENERIC = 'Something went wrong. Please try again.'
const SECURITY_CHECK = 'Security check failed. Please try again.'

const getFBError = (err) => {
  switch (err) {
    case 'auth/admin-restricted-operation':
      return GENERIC
    case 'auth/argument-error':
      return GENERIC
    case 'auth/app-not-authorized':
      return 'Sign-in is not available from this site. Please try again later.'
    case 'auth/app-not-installed':
      return GENERIC
    case 'auth/captcha-check-failed':
      return SECURITY_CHECK
    case 'auth/code-expired':
      return 'The SMS code has expired. Please request a new OTP.'
    case 'auth/cordova-not-ready':
      return GENERIC
    case 'auth/cors-unsupported':
      return 'This browser is not supported. Try a different browser.'
    case 'auth/credential-already-in-use':
      return 'This sign-in method is already linked to another account.'
    case 'auth/custom-token-mismatch':
      return GENERIC
    case 'auth/requires-recent-login':
      return 'Please log in again to continue.'
    case 'auth/dependent-sdk-initialized-before-auth':
      return GENERIC
    case 'auth/dynamic-link-not-activated':
      return GENERIC
    case 'auth/email-change-needs-verification':
      return 'Please verify your email before continuing.'
    case 'auth/email-already-in-use':
      return 'The email address is already in use by another account.'
    case 'auth/emulator-config-failed':
      return GENERIC
    case 'auth/expired-action-code':
      return 'This link has expired. Please request a new one.'
    case 'auth/cancelled-popup-request':
      return 'Sign-in was cancelled. Please try again.'
    case 'auth/internal-error':
      return GENERIC
    case 'auth/invalid-api-key':
      return GENERIC
    case 'auth/invalid-app-credential':
      return SECURITY_CHECK
    case 'auth/invalid-app-id':
      return GENERIC
    case 'auth/invalid-user-token':
      return 'Your session is no longer valid. Please log in again.'
    case 'auth/invalid-auth-event':
      return GENERIC
    case 'auth/invalid-cert-hash':
      return GENERIC
    case 'auth/invalid-verification-code':
      return 'The OTP is incorrect. Please try again.'
    case 'auth/invalid-continue-uri':
      return GENERIC
    case 'auth/invalid-cordova-configuration':
      return GENERIC
    case 'auth/invalid-custom-token':
      return GENERIC
    case 'auth/invalid-dynamic-link-domain':
      return GENERIC
    case 'auth/invalid-email':
      return 'Enter a valid email address.'
    case 'auth/invalid-emulator-scheme':
      return GENERIC
    case 'auth/invalid-credential':
      return 'Email or password is incorrect.'
    case 'auth/invalid-message-payload':
      return GENERIC
    case 'auth/invalid-multi-factor-session':
      return 'Verification failed. Please sign in again.'
    case 'auth/invalid-oauth-client-id':
      return GENERIC
    case 'auth/invalid-oauth-provider':
      return GENERIC
    case 'auth/invalid-action-code':
      return 'This link is invalid or has already been used.'
    case 'auth/unauthorized-domain':
      return 'Sign-in is not available from this site. Please try again later.'
    case 'auth/wrong-password':
      return 'The password is incorrect.'
    case 'auth/invalid-persistence-type':
      return GENERIC
    case 'auth/invalid-phone-number':
      return 'Enter a valid mobile number.'
    case 'auth/invalid-provider-id':
      return GENERIC
    case 'auth/invalid-recipient-email':
      return 'Enter a valid email address.'
    case 'auth/invalid-sender':
      return GENERIC
    case 'auth/invalid-verification-id':
      return 'This OTP session is no longer valid. Please request a new OTP.'
    case 'auth/invalid-tenant-id':
      return GENERIC
    case 'auth/login-blocked':
      return 'Login was blocked. Please try again later.'
    case 'auth/multi-factor-info-not-found':
      return 'Extra verification failed. Please sign in again.'
    case 'auth/multi-factor-auth-required':
      return 'Extra verification is required to sign in.'
    case 'auth/missing-android-pkg-name':
      return GENERIC
    case 'auth/missing-app-credential':
      return SECURITY_CHECK
    case 'auth/auth-domain-config-required':
      return GENERIC
    case 'auth/missing-verification-code':
      return 'Please enter the OTP.'
    case 'auth/missing-continue-uri':
      return GENERIC
    case 'auth/missing-iframe-start':
      return GENERIC
    case 'auth/missing-ios-bundle-id':
      return GENERIC
    case 'auth/missing-or-invalid-nonce':
      return GENERIC
    case 'auth/missing-multi-factor-info':
      return 'Extra verification failed. Please sign in again.'
    case 'auth/missing-multi-factor-session':
      return 'Verification failed. Please sign in again.'
    case 'auth/missing-phone-number':
      return 'Please enter your mobile number.'
    case 'auth/missing-password':
      return 'Please enter a password.'
    case 'auth/missing-verification-id':
      return 'This OTP session is no longer valid. Please request a new OTP.'
    case 'auth/app-deleted':
      return GENERIC
    case 'auth/account-exists-with-different-credential':
      return 'An account already exists with this email. Sign in the way you used before.'
    case 'auth/network-request-failed':
      return 'Network problem. Check your connection and try again.'
    case 'auth/null-user':
      return GENERIC
    case 'auth/no-auth-event':
      return GENERIC
    case 'auth/no-such-provider':
      return 'This sign-in method is not linked to your account.'
    case 'auth/operation-not-allowed':
      return 'This sign-in method is not available right now.'
    case 'auth/operation-not-supported-in-this-environment':
      return 'This browser cannot complete sign-in. Try a different browser.'
    case 'auth/popup-blocked':
      return 'The sign-in window was blocked by your browser. Allow popups and try again.'
    case 'auth/popup-closed-by-user':
      return 'The sign-in window was closed before it finished.'
    case 'auth/provider-already-linked':
      return 'This sign-in method is already linked to your account.'
    case 'auth/quota-exceeded':
      return 'Too many attempts. Please try again later.'
    case 'auth/redirect-cancelled-by-user':
      return 'Sign-in was cancelled. Please try again.'
    case 'auth/redirect-operation-pending':
      return 'Sign-in is already in progress. Please wait.'
    case 'auth/rejected-credential':
      return 'Sign-in failed. Please try again.'
    case 'auth/second-factor-already-in-use':
      return 'This verification method is already in use.'
    case 'auth/maximum-second-factor-count-exceeded':
      return 'No more verification methods can be added.'
    case 'auth/tenant-id-mismatch':
      return GENERIC
    case 'auth/timeout':
      return 'This is taking too long. Please try again.'
    case 'auth/user-token-expired':
      return 'Your session has expired. Please log in again.'
    case 'auth/too-many-requests':
      return 'Too many attempts. Please try again later.'
    case 'auth/unauthorized-continue-uri':
      return GENERIC
    case 'auth/unsupported-first-factor':
      return 'Please sign in with email, phone, or a linked account first.'
    case 'auth/unsupported-persistence-type':
      return GENERIC
    case 'auth/unsupported-tenant-operation':
      return GENERIC
    case 'auth/unverified-email':
      return 'Please verify your email to continue.'
    case 'auth/user-cancelled':
      return 'Sign-in was cancelled.'
    case 'auth/user-not-found':
      return 'No account was found with these details.'
    case 'auth/user-disabled':
      return 'This account has been disabled. Please contact support.'
    case 'auth/user-mismatch':
      return "These details don't match the account you're signed in with."
    case 'auth/user-signed-out':
      return 'You have been signed out. Please log in again.'
    case 'auth/weak-password':
      return 'The password must be 6 characters long or more.'
    case 'auth/web-storage-unsupported':
      return 'This browser is blocking sign-in. Allow cookies and try again.'
    case 'auth/already-initialized':
      return GENERIC
    case 'auth/recaptcha-not-enabled':
      return SECURITY_CHECK
    case 'auth/missing-recaptcha-token':
      return SECURITY_CHECK
    case 'auth/invalid-recaptcha-token':
      return SECURITY_CHECK
    case 'auth/invalid-recaptcha-action':
      return SECURITY_CHECK
    case 'auth/missing-client-type':
      return SECURITY_CHECK
    case 'auth/missing-recaptcha-version':
      return SECURITY_CHECK
    case 'auth/invalid-recaptcha-version':
      return SECURITY_CHECK
    case 'auth/invalid-req-type':
      return GENERIC
    case 'auth/unsupported-password-policy-schema-version':
      return GENERIC
    case 'auth/password-does-not-meet-requirements':
      return 'The password does not meet the requirements.'
    case 'auth/invalid-hosting-link-domain':
      return GENERIC
    default:
      return err
  }
}

export default getFBError
